import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from '../../CSS/DeviceList.module.css'; // Import the CSS module

export const route = '/maintenance';
export const role = 'Maintenance';

const MtnApps = () => {
  const pages = [
    { name: 'Trash Service Requests', path: '/maintenance/daily-service-requests' }
  ];

  return (
    <div className={`container ${styles.directoryContainer} mt-5`}>
      <h1 className="text-center mb-5">Maintenance Apps</h1>
      <div className="row">
        {pages.map((page, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div className={`card shadow-sm ${styles.card}`}>
              <div className="card-body">
                <h5 className="card-title">{page.name}</h5>
                <Link to={page.path} className={`btn btn-primary w-100 ${styles.button}`}>
                  Go to {page.name}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MtnApps;